// One width budget for every step workspace. Grows with the viewport so big
// screens get genuine one-line rows instead of a phone-width ribbon between
// empty gutters; capped so prose line length stays readable.
export const WORKSPACE_WIDTH = 'max-w-3xl lg:max-w-4xl 2xl:max-w-5xl';

// Narrow tier for prose-only views (no full-width list rows): the wide budget
// would sit as a dead right gutter beside prose-capped text, so hug the
// content and let the leftover space fall into symmetric margins instead.
export const WORKSPACE_WIDTH_NARROW = 'max-w-3xl';
